import { $ } from 'utils/dom';
import AniScroll from 'modules/ani-scroll';

const scrollHint = $('[data-hidescroll="true"]');

if (scrollHint) {
  const body = $('body');
  const scrollHintIcon = $('[data-hidescroll="true"] > i');

  const isOverflown = element => {
    return element.scrollHeight > element.clientHeight;
  };

  if (isOverflown(body)) {
    scrollHint.setAttribute('data-hidescroll', 'false');
  }

  setTimeout(function () {
    scrollHintIcon.classList.add('has-animation');
  }, 1200);

  const hideScrollHint = () => {
    scrollHint.setAttribute('data-hidescroll', 'true');

    if (window.pageYOffset === 0) {
      scrollHint.setAttribute('data-hidescroll', 'false');
    }
  };

  const scrollOnClick = () => {
    const buttonHeight = scrollHint.offsetHeight;

    const scrollAmount = window.innerHeight - buttonHeight;
    AniScroll(scrollAmount, 500, 'easeOutQuad');
  };

  window.addEventListener('scroll', hideScrollHint);
  scrollHint.addEventListener('click', scrollOnClick);
}
